<template>
   <vx-card title="Служебные параметры" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Порог активности площадок (кол-во запросов от площадки за предыдущие сутки)"
                        v-model="form.limitActive"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.limitActive"
                        :danger-text="errors.limitActive"/>
                </div>
            </div>
        </div>
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        label="Порог расхода для проверенных площадок (в рублях)"
                        v-model="form.limitUsedBalance"
                        class="mt-1 w-full"
                        type="number"
                        min="0"
                        :danger="!!errors.limitUsedBalance"
                        :danger-text="errors.limitUsedBalance"/>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveSettings()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="clearEdit()" type="filled">
            Отменить
        </vs-button>
<br>
          <vs-button class="mt-4 mr-2" color="warning" @click="refreshSiteNames()" type="filled">
            Обновить справочник названий площадок в Postgres
        </vs-button>
    </vx-card>
</template>


<script>
    export default {
        data() {
            return {
                settings: undefined,
                form: {
                    limitActive: undefined,
                    limitUsedBalance: undefined,
                },
                errors: {
                    limitActive: '',
                    limitUsedBalance: '',
                }
            }
        },
        mounted() {
            this.loadSettings();
        },
        methods: {
            loadSettings() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'GET',
                    url: 'settings/sites',
                    success: (settings) => {
                        this.settings = settings;
                        this.setSettings(settings);

                        this.$vs.loading.close("#loader > .con-vs-loading");
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка получения профиля пользователя!",
                            color: "danger",
                        });
                    }
                })
            },
            setSettings(settings) {
                this.form.limitActive = settings.limitActive;
                this.form.limitUsedBalance = settings.limitUsedBalance;
            },
            clearEdit() {
                this.setSettings(this.settings);
            },
            saveSettings() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'PUT',
                    url: 'settings/sites',
                    params: this.form,
                    errors: this.errors,
                    success: (response) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Настройки успешно обновлены",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при сохранении настроек!",
                            color: "danger",
                        });
                    }
                })
            },
                   refreshSiteNames() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.$axios({
                    method: 'POST',
                    url: 'service/sitesnames',
                    params: this.form,
                    errors: this.errors,
                    success: (response) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Сообщение отправлено",
                            text: "В ближайшее время данные по полощадкам будут обновлены.",
                            color: "success",
                        });
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при отправке сообщения!",
                            color: "danger",
                        });
                    }
                })
            },
        },
        components: {
        },
    }
</script>